import React from 'react';
import profileImg from '../../../assets/img/dummy-profile.png';

const UserList = ({
  handleEditModal,
  userData,
  handelFindTeamMembers,
  handleShowUserSubscriptionModal,
}) => {
  const user = JSON.parse(localStorage.getItem('user_info'));
  return (
    <>
      <tr>
        <td className="TeamMemberImage">
          <img src={profileImg} alt="" />
        </td>
        <td>
          <p>{userData.name}</p>
        </td>
        <td>
          <p>{userData.email}</p>
        </td>
        <td>
          <p>{userData.username}</p>
        </td>
        <td>
          <div className="d-flex align-items-center">
            {userData.email !== user.email && userData.id !== user.id ? (
              <>
                <div className="d-flex">
                  <p
                    className={`LabelButton ${
                      userData.is_verified ? 'SuccessAlert' : 'DangerAlert'
                    }`}
                  >
                    {userData.is_verified ? 'Verified' : 'Unverified'}
                  </p>
                </div>
                <div className="d-flex">
                  <p
                    className={`SmallButton ml-3 ${
                      userData.status === 'Active'
                        ? 'SuccessButton'
                        : 'DangerButton'
                    }`}
                  >
                    {userData.status === 'Active' ? 'ACTIVE' : 'INACTIVE'}
                  </p>
                </div>
              </>
            ) : (
              <p className="ColorPrimary">Main User</p>
            )}
          </div>
        </td>

        <td className="ActionButtonColumn">
          {userData.email !== user.email && userData.id !== user.id ? (
            <>
              <p className="ActionButtonGroup">
                <button
                  onClick={(e) => handleEditModal(userData.id)}
                  className="ActionButton PrimaryAlert"
                  title="Edit"
                >
                  <span className="Icon">
                    <i className="insight wpi-edit" />
                  </span>
                </button>
                <button
                  onClick={(e) => handleShowUserSubscriptionModal(userData.id)}
                  className="ActionButton PrimaryAlert"
                  title="Subscription"
                >
                  <span className="Icon">
                    <i className="insight wpi-subscription" />
                  </span>
                </button>
                {/* <button
                  onClick={(e) => handelFindTeamMembers(userData.id)}
                  class="ActionButton WarningAlert"
                  title="TeamMembers"
                >
                  <span class="Icon">
                    <i class="insight wpi-users"></i>
                  </span>
                </button> */}
                {/* <button
                  className="ActionButton DangerAlert"
                  title="Delete"
                  onClick={(e) => handelDeleteTeamMember(userData.id)}
                >
                  <span className="Icon">
                    <i className="insight wpi-delete"></i>
                  </span>
                </button> */}
              </p>
            </>
          ) : (
            <p className="ColorPrimary"> - </p>
          )}
        </td>
      </tr>
    </>
  );
};

export default UserList;
